import { useDeviceState } from '@/hooks/store';

export const CanadaCountries = ['ca'];
export function useIsCanadaDevice(): boolean {
	const { ip_country: ipCountry } = useDeviceState();

	if (!ipCountry) {
		return false;
	}

	if (!CanadaCountries.includes(ipCountry)) {
		return false;
	}
	return true;
}
